export const getInitialState = (): any => ({
  dataProcessingGroupByData: {},
  dataProcessingGroupByStatus: 0
});
